export enum ChatType
{
    DM,
    EventChat
}